import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Calendar, Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePageMeta } from '@/hooks/usePageMeta';

/**
 * Branded 404 view for unknown routes. `title`/`message` can be overridden so
 * the same layout doubles as the "event/DJ not found" state.
 */
export const NotFound = ({
  code = '404',
  title = 'Page Not Found',
  message = "The page you're looking for doesn't exist or has been moved.",
}) => {
  usePageMeta(title, message);

  return (
    <div className="min-h-screen pt-20 pb-24 md:pb-8 flex items-center justify-center">
      <div className="container mx-auto px-4 max-w-xl text-center">
        <img
          src="/logo.png"
          alt="SoundWolves"
          className="h-16 mx-auto mb-6 object-contain opacity-90"
        />
        <p className="text-7xl sm:text-8xl font-display font-bold text-gradient-gold mb-2">{code}</p>
        <h1 className="text-3xl sm:text-4xl font-display font-bold mb-3">{title}</h1>
        <p className="text-muted-foreground text-lg mb-8">{message}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button variant="premium" size="lg" className="w-full sm:w-auto">
              <Home className="w-5 h-5 mr-2" />
              Back to Home
            </Button>
          </Link>
          <Link to="/events">
            <Button variant="outline" size="lg" className="w-full sm:w-auto">
              <Calendar className="w-5 h-5 mr-2" />
              Browse Events
            </Button>
          </Link>
          <Link to="/djs">
            <Button variant="ghost" size="lg" className="w-full sm:w-auto">
              <Compass className="w-5 h-5 mr-2" />
              Explore DJs
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
